<div class="forgot-password-page">

  <!-- Decorative scattered elements (reusing reset-password assets) -->
  <img class="deco deco--top-left"     src="assets/sketches/1.png" alt="" aria-hidden="true" />
  <img class="deco deco--top-right"    src="assets/sketches/6.png" alt="" aria-hidden="true" />
  <img class="deco deco--heart"        src="assets/sketches/4.png" alt="" aria-hidden="true" />
  <img class="deco deco--plant"        src="assets/sketches/3.png" alt="" aria-hidden="true" />
  <img class="deco deco--bottom-right" src="assets/sketches/5.png" alt="" aria-hidden="true" />

  <!-- Main two-column layout -->
  <div class="page-content">

    <!-- Left: illustration -->
    <div class="illustration-col">
      <img class="doctor-img" src="assets/sketches/female-doc-forgot-password.png" alt="Doctor with key" />
    </div>

    <!-- Right: form -->
    <div class="form-col">
      <h1 class="welcome-title" *ngIf="!errors.length">{{ 'auth.forgotPassword.title' | translate }}</h1>
      <p class="welcome-sub" *ngIf="!errors.length">{{ 'auth.forgotPassword.subtitle' | translate }}</p>

      <!-- Alerts -->
      <div class="alertWrapper">
        <nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
          <p class="alert-title" style="text-align: center;"><b>{{'login.errorTitle' | translate}}</b></p>
          <div class="alert-message-list" style="text-align: center;">
            <span *ngFor="let error of errors" class="alert-message">{{ error }}</span>
          </div>
        </nb-alert>

        <nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert" style="word-wrap: break-word">
          <p class="alert-title"><b>{{'login.successTitle' | translate}}</b></p>
          <ul class="alert-message-list">
            <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
          </ul>
        </nb-alert>
      </div>

      <!-- Email Form (hidden on success) -->
      <div *ngIf="!messages.length"
           [nbSpinner]="submitted"
           nbSpinnerStatus="primary"
           nbSpinnerSize="giant"
           nbSpinnerMessage="">

        <form (ngSubmit)="requestPass()" #form="ngForm" aria-labelledby="title">

          <span class="label-with-link">
            <label class="label" for="input-email">{{ 'auth.forgotPassword.emailLabel' | translate }}</label>
          </span>

          <input nbInput
                 [(ngModel)]="user.email"
                 [showStatusIconOn]="{ showOnControlStatus: ['valid','invalid'] }"
                 #email="ngModel"
                 id="input-email"
                 name="email"
                 pattern=".+@.+\..+"
                 [placeholder]="'auth.forgotPassword.emailLabel' | translate"
                 autofocus
                 fullWidth
                 fieldSize="large"
                 [status]="email.dirty ? (email.invalid ? 'danger' : 'success') : 'basic'"
                 [required]="true"
                 [attr.aria-invalid]="email.invalid && email.touched ? true : null">

          <ng-container *ngIf="email.invalid && email.touched">
            <p class="caption status-danger" *ngIf="email.errors?.['required']">
              {{ 'auth.forgotPassword.emailRequired' | translate }}
            </p>
            <p class="caption status-danger" *ngIf="email.errors?.['pattern']">
              {{ 'auth.forgotPassword.emailInvalid' | translate }}
            </p>
          </ng-container>

          <button class="requestButton"
                  nbButton
                  fullWidth
                  status="primary"
                  size="large"
                  [disabled]="submitted || !form.valid"
                  [class.btn-pulse]="submitted">
            {{ 'auth.forgotPassword.submitButton' | translate }}
          </button>
        </form>

      </div>

      <section class="sign-in-or-up" aria-label="Sign in">
        <p><a class="text-link" routerLink="/userLogin">{{ 'auth.forgotPassword.backToLogin' | translate }}</a></p>
      </section>
    </div>

  </div>
</div>
